import { render } from "./InnerLayout.vue?vue&type=template&id=49b407e1&scoped=true"
const script = {}

import "./InnerLayout.vue?vue&type=style&index=0&id=49b407e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b407e1"]])

export default __exports__